function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import SignupButton from "segments/desktop/core-components/button/signup-button/signup-button";
import ContactSalesButton from "segments/desktop/core-components/contact-sales-button/contact-sales-button";
import classnames from "classnames";
import DefaultProps from "./default-props";
import { StyledGetStartedContactSalesComboButton } from "./get-started-contact-sales-combo-button.scss";
import MondayMarkupLanguageComponent from "client/components/system/monday-markup-language/monday-markup-language-component";
class GetStartedContactSalesComboButton extends PureComponent {
    render() {
        const { contactSalesButtonConfig, signupButtonConfig, swapButtonsOrder, additionalText, additionalTextPosition, additionalTextMaxWidth, buttonsAlign } = this.props;
        return /*#__PURE__*/ _jsxs(StyledGetStartedContactSalesComboButton, {
            buttonsAlign: buttonsAlign,
            className: classnames("get-started-contact-sales-combo-button", swapButtonsOrder && "swap-buttons-order"),
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "signup-button-wrapper",
                    children: /*#__PURE__*/ _jsx(SignupButton, _object_spread({}, signupButtonConfig))
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "contact-sales-button-wrapper",
                    children: /*#__PURE__*/ _jsx(ContactSalesButton, _object_spread_props(_object_spread({}, contactSalesButtonConfig), {
                        buttonSize: "lg"
                    }))
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: classnames("additional-button-text", additionalTextPosition),
                    style: {
                        maxWidth: additionalTextMaxWidth
                    },
                    children: /*#__PURE__*/ _jsx(MondayMarkupLanguageComponent, {
                        text: additionalText
                    })
                })
            ]
        });
    }
}
export { GetStartedContactSalesComboButton as default };
GetStartedContactSalesComboButton.defaultProps = DefaultProps;
